import { useState, useRef, createRef, useEffect } from "react";
import Logo from "../../assets/svg/logo";
import ContectUs from "../../assets/svg/contactus";
import {
  Box1,
  Box2,
  Box3,
  Box4,
  Box5,
  Box6,
  BoxContainer,
  // BrowseOpportunitiesButton,
  ButtonsDisplay,
  ContactUsButton,
  Container,
  Heading,
  HeadingText,
  MenuText,
  MenuWrapper,
  MobileWrapper,
  Navbar,
  Navigation,
  NavigationMenu,
  NavWrapper,
  RoundArrow,
  SidebarContent,
  SideNav,
  SideNavBox,
  Text,
} from "../../styles/pages/home";
import BasicInfo from "../../views/home";
import Connections from "../../views/connections";
import ConnectionsInfo from "../../views/connectionsInfo";
import Achievements from "../../views/Achievements";
import GateWay from "../../views/gateway";
import ClientView from "../../views/clientView";
import Policy from "../../views/policy";
import ContactUs from "../../views/contactus";
import AboutUs from "../../views/aboutUs";
import Faq from "../../views/faq";
import Footer from "../../components/Footer";
import Heading1 from "../../assets/svg/heading1";
import Header2 from "../../assets/svg/header2";
import Blog from "../../views/blog";
import Menu from "../../assets/svg/menu";
import { Drawer } from "@mui/material";

const Home = () => {
  const [activeLink, setActiveLink] = useState("home");
  const refs: any = {
    home: useRef<HTMLDivElement | null>(null),
    about: useRef<HTMLDivElement | null>(null),
    services: useRef<HTMLDivElement | null>(null),
    caseStudies: useRef<HTMLDivElement | null>(null),
    blog: useRef<HTMLDivElement | null>(null),
    contactUs: useRef<HTMLDivElement | null>(null),
  };

  const handleScroll = () => {
    const offsetTop = window.scrollY; // Replace pageYOffset with scrollY

    for (const [key, ref] of Object.entries(refs) as any) {
      if (ref.current) {
        const sectionTop = ref.current.offsetTop;
        const sectionHeight = ref.current.offsetHeight;

        // Check if the section is in view
        if (offsetTop >= sectionTop - sectionHeight / 3 && offsetTop < sectionTop + sectionHeight / 3) {
          setActiveLink(key);
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = (link: string) => {
    setActiveLink(link);
    const section = refs[link];
    if (section?.current) {
      section.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  };

  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = (open: any) => () => {
    setSidebarOpen(open);
  };

  return (
    <>
      <div ref={refs.home}>
        <Container>
          <Navbar>
            <NavWrapper>
              <SideNav>
                <Logo />
              </SideNav>
              <NavigationMenu onClick={toggleSidebar(true)}>
                <MenuWrapper>
                  <Menu />
                </MenuWrapper>
                <MenuText>Menu</MenuText>
              </NavigationMenu>
              <Navigation>
                <a href="#" className={activeLink === "home" ? "active" : ""} onClick={() => handleLinkClick("home")}>
                  Home
                </a>
                <a href="#" className={activeLink === "about" ? "active" : ""} onClick={() => handleLinkClick("about")}>
                  About Us
                </a>
                <a
                  href="#"
                  className={activeLink === "services" ? "active" : ""}
                  onClick={() => handleLinkClick("services")}>
                  Services
                </a>
                <a
                  href="#"
                  className={activeLink === "caseStudies" ? "active" : ""}
                  onClick={() => handleLinkClick("caseStudies")}>
                  How We Work
                </a>
                <a href="#" className={activeLink === "blog" ? "active" : ""} onClick={() => handleLinkClick("blog")}>
                  Blog
                </a>
              </Navigation>
              <SideNavBox>
                <ContactUsButton onClick={() => handleLinkClick("contactUs")}>
                  <RoundArrow>
                    <ContectUs />
                  </RoundArrow>
                  <Text>Contact Us</Text>
                </ContactUsButton>
              </SideNavBox>
            </NavWrapper>
          </Navbar>
          <div ref={refs.home}>
            {/* mobile */}
            <MobileWrapper>
              <Heading>Enabling Global Professionals to Thrive in India's Diverse Industries</Heading>
              <HeadingText>
                Connecting skilled professionals worldwide with top Indian projects. Begin your journey to impactful
                roles in construction and engineering
              </HeadingText>
              <ButtonsDisplay>
                <Heading1 />

                {/* <BrowseOpportunitiesButton>
                  <RoundArrow>
                    <ContectUs />
                  </RoundArrow>
                  <Text>Browse Opportunities</Text>
                </BrowseOpportunitiesButton> */}

                <Header2 />
              </ButtonsDisplay>
              <BoxContainer>
                <Box1>#ConstructionCareers</Box1>
                <Box2>#InfrastructureJobs</Box2>
                <Box3>#WorkInIndia</Box3>
                <Box4>#TalentWithoutBorders</Box4>
                <Box5>#SkilledProfessionals</Box5>
                <Box6>#InternationalRecruitment</Box6>
              </BoxContainer>
            </MobileWrapper>
          </div>
        </Container>
      </div>
      <BasicInfo />

      <Connections />

      <div ref={refs.about}>
        <ConnectionsInfo />
      </div>

      <div ref={refs.services}>
        <Achievements />
      </div>

      <div ref={refs.caseStudies}>
        <GateWay />
      </div>
      <ClientView />
      <Policy />
      <div ref={refs.blog}>
        <Blog />
      </div>
      <div ref={refs.contactUs}>
        <ContactUs />
      </div>

      <AboutUs />

      <Faq />
      <Footer refs={refs} handleLinkClick={handleLinkClick} />

      <Drawer anchor="left" open={isSidebarOpen} onClose={toggleSidebar(false)}>
        <SidebarContent>
          <h3>Menu</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {[
              { name: "Home", link: "home" },
              { name: "About Us", link: "about" },
              { name: "Services", link: "services" },
              { name: "How We Work", link: "caseStudies" },
              { name: "Blog", link: "blog" },
            ].map(item => (
              <div
                key={item.link}
                onClick={() => {
                  handleLinkClick(item.link);
                  setSidebarOpen(false);
                }}
                style={{
                  cursor: "pointer",
                  color: activeLink === item.link ? "#267dff" : "#222737", // Change color or add a style for the active link
                  fontWeight: activeLink === item.link ? "bold" : "normal", // Example of bold text for active
                }}>
                {item.name}
              </div>
            ))}
          </div>
        </SidebarContent>
      </Drawer>
    </>
  );
};

export default Home;
